/**
 * Files Page Translations
 */

import { Translations } from '../shared/i18n';

export const filesTranslations: Translations = {
    tr: {
        navFiles: 'Tüm Belgeler',
        filesTitle: 'Tüm Belgeler',
        filesDescription: 'Yüklenen tüm belgeleriniz, tarih, tutar ve detaylarıyla',
        filesFolderExpenses: 'Giderler',
        filesFolderRevenue: 'Gelirler',
        filesFolderStatements: 'Banka Ekstreleri',
        filesDownload: 'İndir',
        filesDelete: 'Sil',
        filesDeleteTitle: 'Dosyayı Sil',
        filesDeleteMessage: 'Bu dosyayı silmek istediğinize emin misiniz? Varsa eşleştirme bağları da kaldırılacaktır.',
        filesDeleteConfirm: 'Sil',
        filesDeleteCancel: 'İptal',
        filesEmpty: 'Henüz dosya yüklenmemiş',
        filesDeleteSuccess: 'Dosya silindi',
        filesDeleteError: 'Dosya silinemedi',
        filesDocDate: 'Belge Tarihi',
        filesUploadDate: 'Yüklenme',
    },
    en: {
        navFiles: 'All Documents',
        filesTitle: 'All Documents',
        filesDescription: 'All your uploaded documents with dates, amounts & details',
        filesFolderExpenses: 'Expenses',
        filesFolderRevenue: 'Revenues',
        filesFolderStatements: 'Bank Statements',
        filesDownload: 'Download',
        filesDelete: 'Delete',
        filesDeleteTitle: 'Delete File',
        filesDeleteMessage: 'Are you sure you want to delete this file? Any reconciliation links will also be removed.',
        filesDeleteConfirm: 'Delete',
        filesDeleteCancel: 'Cancel',
        filesEmpty: 'No files uploaded yet',
        filesDeleteSuccess: 'File deleted',
        filesDeleteError: 'Failed to delete file',
        filesDocDate: 'Document Date',
        filesUploadDate: 'Uploaded',
    },
    de: {
        navFiles: 'Alle Dokumente',
        filesTitle: 'Alle Dokumente',
        filesDescription: 'Alle hochgeladenen Dokumente mit Datum, Betrag & Details',
        filesFolderExpenses: 'Ausgaben',
        filesFolderRevenue: 'Einnahmen',
        filesFolderStatements: 'Kontoauszüge',
        filesDownload: 'Herunterladen',
        filesDelete: 'Löschen',
        filesDeleteTitle: 'Datei löschen',
        filesDeleteMessage: 'Möchten Sie diese Datei wirklich löschen? Alle Abgleich-Verknüpfungen werden ebenfalls entfernt.',
        filesDeleteConfirm: 'Löschen',
        filesDeleteCancel: 'Abbrechen',
        filesEmpty: 'Noch keine Dateien hochgeladen',
        filesDeleteSuccess: 'Datei gelöscht',
        filesDeleteError: 'Datei konnte nicht gelöscht werden',
        filesDocDate: 'Belegdatum',
        filesUploadDate: 'Hochgeladen',
    },
};
